(function () {
    var config = window.GRIDLINK_REP_NOTIFICATION || null;
    var WRAP_FLAG = '__gridlinkRepNotificationWrapped';
    var STORAGE_KEY = 'gridlink_sparklayer_active_impersonation';
    var POLL_INTERVAL_MS = 250;
    var MAX_WAIT_MS = 15000;

    function isEnabled() {
        return !!(config && config.enabled && config.endpointPath);
    }

    function nowIso() {
        return new Date().toISOString();
    }

    function createEventId() {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
            return window.crypto.randomUUID();
        }

        return 'evt-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    }

    function readActiveEvent() {
        try {
            var raw = window.sessionStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch (error) {
            return null;
        }
    }

    function writeActiveEvent(payload) {
        try {
            window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        } catch (error) {
        }
    }

    function clearActiveEvent() {
        try {
            window.sessionStorage.removeItem(STORAGE_KEY);
        } catch (error) {
        }
    }

    function buildRepHint() {
        return {
            email: config && config.currentCustomerEmail ? config.currentCustomerEmail : null
        };
    }

    function postEvent(payload) {
        if (!isEnabled()) {
            return Promise.resolve({ skipped: true });
        }

        return fetch(config.endpointPath, {
            method: 'POST',
            credentials: 'same-origin',
            keepalive: true,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).catch(function (error) {
            console.warn('Gridlink rep notification failed', error);
        });
    }

    function buildStartedPayload(customerId) {
        var eventId = createEventId();
        var startedAt = nowIso();

        return {
            event_name: 'agent_impersonation_started',
            event_id: eventId,
            started_at: startedAt,
            detector_version: config && config.detectorVersion ? config.detectorVersion : 'theme-sparklayer-hook-v1',
            spark_customer_id: String(customerId),
            target_customer_id: String(customerId),
            page_url: window.location.href,
            rep_hint: buildRepHint()
        };
    }

    function buildEndedPayload(activeEvent) {
        return {
            event_name: 'agent_impersonation_ended',
            event_id: activeEvent.event_id,
            started_at: activeEvent.started_at,
            ended_at: nowIso(),
            detector_version: activeEvent.detector_version,
            spark_customer_id: activeEvent.spark_customer_id,
            target_customer_id: activeEvent.target_customer_id,
            page_url: window.location.href,
            rep_hint: buildRepHint()
        };
    }

    function normalizeCustomerId(value) {
        if (value === null || value === undefined) {
            return '';
        }

        var normalized = String(value).trim();
        return normalized;
    }

    function startImpersonation(customerId) {
        var payload = buildStartedPayload(customerId);
        writeActiveEvent(payload);
        void postEvent(payload);
    }

    function endImpersonation(activeEvent) {
        var payload = buildEndedPayload(activeEvent);
        clearActiveEvent();
        void postEvent(payload);
    }

    function wrapSparkImpersonation() {
        if (!window.spark || typeof window.spark.switchImpersonatingCustomer !== 'function') {
            return false;
        }

        if (window.spark.switchImpersonatingCustomer[WRAP_FLAG]) {
            return true;
        }

        var originalSwitch = window.spark.switchImpersonatingCustomer;
        var wrappedSwitch = function () {
            var args = arguments;
            var nextCustomerId = normalizeCustomerId(args[0]);
            var activeEvent = readActiveEvent();

            if (activeEvent && (!nextCustomerId || nextCustomerId !== activeEvent.target_customer_id)) {
                endImpersonation(activeEvent);
                activeEvent = null;
            }

            if (nextCustomerId) {
                if (!activeEvent || activeEvent.target_customer_id !== nextCustomerId) {
                    startImpersonation(nextCustomerId);
                }
            }

            return originalSwitch.apply(this, args);
        };

        wrappedSwitch[WRAP_FLAG] = true;
        window.spark.switchImpersonatingCustomer = wrappedSwitch;
        return true;
    }

    function bootstrap() {
        if (!config) {
            return;
        }

        var startTime = Date.now();
        var timerId = window.setInterval(function () {
            var wrapped = wrapSparkImpersonation();
            if (wrapped) {
                window.clearInterval(timerId);
                return;
            }

            if (Date.now() - startTime > MAX_WAIT_MS) {
                window.clearInterval(timerId);
            }
        }, POLL_INTERVAL_MS);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
        bootstrap();
    }
})();
